import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({ sra, setSra, setStep, storedUser }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const type = JSON.parse(localStorage.getItem("type"));

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    // Vendor Code
    if (isEmpty(data.code)) {
      newErrors.code = "Vendor Code is required";
    }

    // Vendor Name
    if (isEmpty(data.name)) {
      newErrors.name = "Vendor Name is required";
    }

    // Amount
    if (isEmpty(data.amount)) {
      newErrors.amount = "Total Amount is required";
    } else if (isNaN(data.amount) || Number(data.amount) <= 0) {
      newErrors.amount = "Enter a valid positive amount";
    }

    // Vendor Details
    if (isEmpty(data.details)) {
      newErrors.details = "Vendor Details are required";
    } else if (data.details.length > 250) {
      newErrors.details = "Vendor Details must be up to 250 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Write {type} - Advances Given</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="sapNumber">SAP Document Number</label>
            <input
              className={`${errors.sapNumber && "input-error"}`}
              type="text"
              name="sapNumber"
              id="sapNumber"
              onChange={handleChange}
              value={sra?.sapNumber || ""}
            />
            {errors.sapNumber && <p className="error">{errors.sapNumber}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="code">
              Vendor Code <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.code && "input-error"}`}
              type="text"
              name="code"
              id="code"
              onChange={handleChange}
              value={sra?.code || ""}
            />
            {errors.code && <p className="error">{errors.code}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="name">
              Vendor Name <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.name && "input-error"}`}
              type="text"
              name="name"
              id="name"
              onChange={handleChange}
              value={sra?.name || ""}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="amount">
              Total Amount <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.amount && "input-error"}`}
              type="number"
              step="0.01"
              name="amount"
              id="amount"
              onChange={handleChange}
              value={sra?.amount || ""}
            />
            {errors.amount && <p className="error">{errors.amount}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="details">
              Vendor Details <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.details && "input-error"}`}
              type="text"
              name="details"
              id="details"
              onChange={handleChange}
              value={sra?.details || ""}
              rows={4}
            />
            {errors.details && <p className="error">{errors.details}</p>}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
